module.exports = __webpack_public_path__ + "img/Custom.69eacb1b.svg";